import React from "react";

function Footer() {
  let d = new Date();
  return (
    <div className="bg-dark">
      <div
        style={{ width: "fitContent" }}
        className="text-center text-white mx-auto py-2"
      >
        <a href={window.location.origin} className="text-white">
          © shivaji{" "}
        </a>
        {d.getFullYear()} All Rights Reserved.
      </div>
    </div>
  );
}

export default Footer;
